import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 19.3C3 19 3.1 18.8 3.3 18.6L9 12.9L11.1 15L5.4 20.7C5.2 20.9 5 21 4.7 21H4.5C4.3 21 4 20.9 3.8 20.7L3.3 20.2C3.1 20 3 19.8 3 19.5V19.3ZM21 7C21 9.2 19.2 11 17 11C16.5 11 15.9 10.9 15.5 10.7L13.8 12.4L15 13.6L15.5 13.1C15.7 12.9 16 12.9 16.2 13.1L20.7 17.6C20.9 17.8 21 18 21 18.3V19.5C21 19.8 20.9 20 20.7 20.2L20.2 20.7C20 20.9 19.8 21 19.5 21H18.3C18 21 17.8 20.9 17.6 20.7L13.1 16.2C12.9 16 12.9 15.7 13.1 15.5L13.6 15L6.8 8.2L5.2 7.3C4.9 7.2 4.6 7 4.5 6.6L3.1 4.6C3 4.4 3 4.2 3.2 4L4 3.1C4.2 3 4.4 3 4.6 3.1L6.7 4.4C7 4.6 7.2 4.9 7.3 5.2L8.2 6.8L11.6 10.3L13.3 8.6C13.1 8.1 13 7.5 13 7C13 4.8 14.8 3 17 3H17.3C17.5 3 17.6 3 17.7 3.1L17.9 3.3C18.1 3.5 18.1 3.8 17.9 4L16.3 5.6C16.1 5.8 16.1 6.1 16.3 6.3L17.7 7.7C17.9 7.9 18.2 7.9 18.4 7.7L20 6.1C20.2 6 20.5 6 20.7 6.1L20.9 6.3C20.9 6.35 20.925 6.425 20.95 6.5C20.975 6.575 21 6.65 21 6.7V7Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgTools = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgTools;
